import { IPCIDR } from '../source-names/ipcidr'

interface CidrRange {
  min: string
  max: string
}

export const calculateIpRange = (
  cidrBlock: string = ''
): CidrRange | undefined => {
  if (cidrBlock.length === 0 || cidrBlock.indexOf('/') === -1) {
    return undefined
  }
  const cidr = new IPCIDR(cidrBlock)

  if (!cidr.isValid()) {
    return undefined
  }

  return {
    min: cidr.start(),
    max: cidr.end()
  }
}
